import { render } from "./RepairRecordList.vue?vue&type=template&id=255da883&scoped=true"
import script from "./RepairRecordList.vue?vue&type=script&lang=js"
export * from "./RepairRecordList.vue?vue&type=script&lang=js"

import "./RepairRecordList.vue?vue&type=style&index=0&id=255da883&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255da883"]])

export default __exports__